/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Metadata_Merge_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to merge metadata: {error}" |
*
* @param {Metadata_Merge_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_failed = /** @type {((inputs: Metadata_Merge_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de la fusion des métadonnées : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Metadaten konnten nicht zusammengeführt werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile unire i metadati: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось объединить метаданные: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al fusionar los metadatos: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`合并元数据失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`メタデータのマージに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`मेटाडेटा को मर्ज करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao mesclar metadados: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to merge metadata: ${i?.error}`)
});